export const leadershipSkills = [
    {
        title: 'People',
        items: [
            'Mentoring and developer growth',
            'Leading software teams',
            'Interviewing and selecting engineers',
            'Annual performance evaluations',
        ],
    },
    {
        title: 'Delivery',
        items: [
            'Guiding teams through high-impact releases',
            'Resolving workflow inefficiencies',
            'Sprint planning and technical roadmaps',
            'Software release and metrics tracking',
        ],
    },
    {
        title: 'Product and cross-functional',
        items: [
            'Aligning product goals with technical requirements',
            'Building a culture of collaboration',
            'Working with cross-functional stakeholders',
        ],
    },
    {
        title: 'Technical direction',
        items: [
            'Full stack system design and architecture',
            'Automated testing strategy',
            'Clean, well-documented codebases',
        ],
    },
]

export const technicalSkills = [
    {
        label: 'Languages',
        outlined: false,
        skills: ['TypeScript', 'JavaScript', 'Python', 'SQL'],
    },
    {
        label: 'Frameworks',
        outlined: false,
        skills: ['React', 'Next.js', 'Express', 'Apollo Server'],
    },
    {
        label: 'Cloud',
        outlined: false,
        skills: ['AWS Lambda', 'AWS SQS/SNS', 'AWS RDS', 'Firebase'],
    },
    {
        label: 'Testing',
        outlined: false,
        skills: ['Jest', 'Cypress', 'Cucumber'],
    },
    {
        label: 'Tools',
        outlined: false,
        skills: ['Docker', 'GitLab CI/CD'],
    },
    {
        label: 'Also worked with',
        outlined: true,
        skills: ['Java', 'Django', 'Flask', 'PHP'],
    },
]
